import React from 'react';
import './LoginLoader.scss';

/**
 * Full-screen loader for the login / public routes on hard refresh: the dark
 * gridded ground of the login visual with a small cluster of animated red bars
 * centred in it. No blue spinner.
 */
const LoginLoader = () => (
	<div className="ivs-loginloader" role="status" aria-busy="true" aria-label="Loading">
		<div className="ivs-loginloader__bars" aria-hidden="true">
			{Array.from({ length: 6 }).map((_, i) => (
				<span key={i} style={{ animationDelay: `${i * 0.11}s` }} />
			))}
		</div>
	</div>
);

export default LoginLoader;
